module.exports = __webpack_public_path__ + "img/silver2.d71ad1b1.png";